import { createContext } from "react";
import type { IExtractionState } from "@hooks/extraction/useExtraction";
import type { IDoctypeState } from "@src/hooks/flow/useDoctype";

export interface IApplicationContextType {
  extraction: IExtractionState;
  doctype: IDoctypeState;
}

export const ApplicationContext = createContext<
  IApplicationContextType | undefined
>(undefined);
